import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/default/lang/langs/langs'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: document.querySelector('html').getAttribute('lang'),
  fallbackLocale: 'pt-BR',
  messages: messages
})
